import { render, staticRenderFns } from "./PeopleSearch.vue?vue&type=template&id=62deed6a"
import script from "./PeopleSearch.vue?vue&type=script&lang=ts"
export * from "./PeopleSearch.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports